import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Search } from './icons';

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchInput({ value, onChange, placeholder = 'Search' }: SearchInputProps) {
  return (
    <TextField
      variant="standard"
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {/* Colour: `sx.color` here does NOT reach the rendered icon — theme.ts's
                MuiInput override (`'& .MuiInputAdornment-root svg path': { stroke: '#97A2AA', ... }`)
                targets this exact composition and wins over the icon's own sx. The
                `color: '#97A2AA'` below is intentionally redundant with that theme
                value (kept so size + intended colour are visible together); changing
                it will have no visual effect — change theme.ts's MuiInput override
                instead if this icon's colour ever needs to differ. */}
            <Search sx={{ width: 16, height: 16, color: '#97A2AA' }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
